import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppSettingsTrainingPopupPage } from './app-settings-training-popup';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppSettingsTrainingPopupPage,
  ],
  imports: [
    IonicPageModule.forChild(AppSettingsTrainingPopupPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppSettingsTrainingPopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-settings-training-popup/app-settings-training-popup.module.ts